// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgMenuSettings = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#menu_settings_svg__a)">
      <path
        fill={props.color ?? 'currentColor'}
        d="m15.032 7-2.48-.352a4.6 4.6 0 0 0-.376-.912l1.504-2.008a.255.255 0 0 0-.024-.328l-1.064-1.064a.254.254 0 0 0-.328-.024l-2.008 1.504a4.6 4.6 0 0 0-.912-.376L8.992.96a.25.25 0 0 0-.248-.216H7.24a.244.244 0 0 0-.248.216L6.64 3.44c-.32.096-.624.216-.912.376L3.72 2.312a.255.255 0 0 0-.328.024L2.328 3.4a.254.254 0 0 0-.024.328l1.504 2.008c-.16.288-.28.592-.376.912L.952 7a.25.25 0 0 0-.216.248v1.504c0 .128.088.232.216.248l2.48.352c.096.32.216.624.376.912l-1.504 2.008a.255.255 0 0 0 .024.328l1.064 1.064a.25.25 0 0 0 .176.072.26.26 0 0 0 .152-.048l2.008-1.504c.288.16.592.28.912.376l.352 2.48a.25.25 0 0 0 .248.216h1.504a.244.244 0 0 0 .248-.216l.352-2.48c.32-.096.624-.216.912-.376l2.008 1.504a.26.26 0 0 0 .152.048.25.25 0 0 0 .176-.072l1.064-1.064a.254.254 0 0 0 .024-.328l-1.504-2.008c.16-.288.28-.592.376-.912L15.032 9a.25.25 0 0 0 .216-.248V7.248A.244.244 0 0 0 15.032 7M8 10A2 2 0 1 1 8 5.998 2 2 0 0 1 8 10"
      />
    </g>
    <defs>
      <clipPath id="menu_settings_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgMenuSettings
